<template>
    <div class="sign-up">
      <!-- <h1>{{ msg }}</h1> -->
      <img class="logo" alt="Vue logo" src="../assets/logo.png">
      <h1>Sign Up</h1>
      
      <div class="signUp">
        <input type="text" placeholder="Enter name" v-model="name"/>
        <input type="text" placeholder="Enter name" v-model="email"/>
        <input type="text" placeholder="Enter name" v-model="password"/>
        <button v-on:click="SignIn">Sign Up</button>
    </div>

    </div>
  </template>
  
  <script>
  import axios from 'axios'
  export default {
    name: 'SignUp',
    props: {
      msg: String
    },
    data(){
        return{
            name:'',
            email:'',
            password:''
        }
    },
    methods:{
        async SignIn(){
            let result = await axios.post("gggg", {
                email:this.email,
                password:this.password,
                name:this.name
            });
            // console.warn(result);
            if(result.status == 201){
                alert("log in successfull");
                localStorage.setItem("user-info", JSON.stringify(result.data));
                this.$router.push({name:'Home'})  //to redirect to home page
            }
        }
    },
    mounted(){
        let user = localStorage.getItem('user-info');
        if (user)
        {
            this.$router.push({name:'Home'})
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>

  .logo{
    width: 100px;
  }

  .signUp{
    
    margin-left: auto;
    margin-right: auto;
  }

  .signUp input{
    width: 300px;
    height: 40px;
    padding-left: 20px;
    display: block;
    margin-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
    border: 1px solid skyblue;
  }

  .signUp button{
    width: 320px;
    height: 40px;
    border: 1px solid skyblue;
    background: skyblue;
    color: white;
    cursor: pointer;
  }
  
  </style>
  